export const PATTERNS = {
  // =========================
  // Public / Auth
  // =========================
  home: "/",

  login: "/login",
  forgotPassword: "/forgot-password",
  createNewPassword: "/reset-password/*",
  signUp: "/sign-up",

  invitation: "/team-members/invitation/:uuid",
  selectTeam: "/select-team",
  // Autopto onboarding steps, shown full-screen until the team completes them.
  onboardingPlatform: "/onboarding/platform",
  onboardingSurvey: "/onboarding/survey",
  // The one-time Autopto offer, right after the first card.
  autoptoOffer: "/offer",

  verifyMfa: "/verify-mfa",
  unlock: "/unlock",
  demoLogin: "/demo-login",
  // Emailed subscription link: redeems it for a brand-new account.
  activateAccount: "/activate/:code",

  // =========================
  // Global protected pages
  // =========================
  apiKeys: "/api-keys",
  teamMembers: "/team-members",
  notifications: "/notifications",
  settings: "/settings",
  settingsTab: "/settings/:tabId",

  // =========================
  // Sites (main section)
  // =========================
  sites: "/sites",
  newSiteWizard: "/sites/wizard/:tab?",

  // Site root (AnalyticsPage)
  siteRoot: "/sites/:id",

  // Site settings
  siteSettings: "/sites/:id/settings",
  siteSettingsTab: "/sites/:id/settings/:tabId",

  // Pages
  sitePages: "/sites/:id/pages",

  // Live editor subtree
  siteLiveEditor: "/sites/:id/live-editor",
  siteLiveEditorInstall: "/sites/:id/live-editor/install",
  siteLiveEditorCustomizations: "/sites/:id/live-editor/customizations",

  // Links
  siteLinksOverview: "/sites/:id/links/overview",

  siteLinksNiche: "/sites/:id/links/niche-links",
  siteLinksNicheTask: "/sites/:id/links/niche-links/:taskId",

  siteLinksOutreach: "/sites/:id/links/outreach-links",
  siteLinksOutreachTask: "/sites/:id/links/outreach-links/:taskId",

  siteLinksBrand: "/sites/:id/links/brand-links",
  siteLinksBrandTask: "/sites/:id/links/brand-links/:taskId",

  // Keywords subtree
  siteKeywordsList: "/sites/:id/keywords",
  siteKeyword: "/sites/:id/keywords/:keywordId",
  siteKeywordImports: "/sites/:id/keywords/imports",
  siteKeywordImport: "/sites/:id/keywords/imports/:importId",

  // Reports subtree
  siteReports: "/sites/:id/reports",
  siteReportsBuiltLinks: "/sites/:id/reports/built-links",
  siteReportsKeywordRanking: "/sites/:id/reports/keyword-ranking",
  siteReportsSiteSales: "/sites/:id/reports/site-sales",
  siteReportsRecommendationExports: "/sites/:id/reports/recommendation-exports",
  siteReportsWorkDone: "/sites/:id/reports/work-done",
  siteReportsClient: "/sites/:id/reports/client",

  // Onpage / content / schema / interlinks
  siteOnpage: "/sites/:id/onpage",
  siteContent: "/sites/:id/content",
  siteSchema: "/sites/:id/schema",
  siteAiInstructions: "/sites/:id/ai-instructions",
  siteInterlinks: "/sites/:id/interlinks",

  // Google dashboard
  siteGoogleDashboard: "/sites/:id/google-dashboard",

  // Site traffic metrics (per-site traffic analytics)
  siteTrafficMetrics: "/sites/:id/visibility-engine/traffic",
  siteVisibilityMetrics: "/sites/:id/visibility-engine/metrics",
  siteVisibilityEngineSettings: "/sites/:id/visibility-engine/settings",
  siteVisibilityEngineSettingsTab:
    "/sites/:id/visibility-engine/settings/:tabId",

  // Visibility Engine domains module mirrored into the site context
  siteVisibilityEngineDomain: "/sites/:id/visibility-engine/domains/:domainId",
  siteVisibilityEngineAbout: "/sites/:id/visibility-engine/about",

  // =========================
  // Visibility Engine (site speed)
  // =========================
  visibilityEngine: "/visibility-engine",
  visibilityEngineDomains: "/visibility-engine/domains",
  visibilityEngineDomain: "/visibility-engine/domains/:domainId",

  visibilityEngineWizardSetup:
    "/visibility-engine/domains/:domainId/wizard/setup",
  visibilityEngineWizardVerification:
    "/visibility-engine/domains/:domainId/wizard/verification",
  visibilityEngineWizardCertificate:
    "/visibility-engine/domains/:domainId/wizard/certificate",
  visibilityEngineWizardDns: "/visibility-engine/domains/:domainId/wizard/dns",
  visibilityEngineWizardNs: "/visibility-engine/domains/:domainId/wizard/ns",
  visibilityEngineWizardRouting:
    "/visibility-engine/domains/:domainId/wizard/routing",
  visibilityEngineWizardInstall:
    "/visibility-engine/domains/:domainId/wizard/install",
  visibilityEngineWizardConfigure:
    "/visibility-engine/domains/:domainId/wizard/configure",

  // =========================
  // Services
  // =========================
  services: "/services",
  servicesOrders: "/services/orders",
  servicesBrandLinks: "/services/brand-links",
  servicesNicheLinks: "/services/niche-links",
  servicesConciergeInstallation: "/services/concierge-installation",
  llm_citations: "/services/llm-citations",
  servicesCommunityLinks: "/services/community-links",

  // =========================
  // Billing section (separate tree)
  // =========================
  billing: "/billing",
  billingInvoices: "/billing/invoices",
  billingSubscription: "/billing/subscription",
  billingSubscriptionEdit: "/billing/subscription/edit",

  // =========================
  // Personal subscription links
  // =========================
  subscribe: "/subscribe/:code",
} as const;
